import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const regions = [
  { id: 'gcc', name: 'GCC' },
  { id: 'levant', name: 'Levant' },
  { id: 'north-africa', name: 'North Africa' }
];

const countries = [
  { id: 'uae', name: 'UAE', region: 'gcc' },
  { id: 'ksa', name: 'Saudi Arabia', region: 'gcc' },
  { id: 'kuwait', name: 'Kuwait', region: 'gcc' },
  { id: 'qatar', name: 'Qatar', region: 'gcc' },
  { id: 'bahrain', name: 'Bahrain', region: 'gcc' },
  { id: 'oman', name: 'Oman', region: 'gcc' },
  { id: 'jordan', name: 'Jordan', region: 'levant' },
  { id: 'lebanon', name: 'Lebanon', region: 'levant' },
  { id: 'egypt', name: 'Egypt', region: 'north-africa' },
  { id: 'morocco', name: 'Morocco', region: 'north-africa' },
  { id: 'tunisia', name: 'Tunisia', region: 'north-africa' }
];

function LocationSwitcher({ selectedRegion, selectedCountry, onRegionChange, onCountryChange }) {
  return (
    <div className="flex space-x-4">
      <Menu as="div" className="relative inline-block text-left">
        <Menu.Button className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none">
          {regions.find(r => r.id === selectedRegion)?.name || 'Select Region'}
          <ChevronDownIcon className="w-5 h-5 ml-2 -mr-1" aria-hidden="true" />
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute left-0 z-10 w-56 mt-2 origin-top-left bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="py-1">
              {regions.map((region) => (
                <Menu.Item key={region.id}>
                  {({ active }) => (
                    <button
                      onClick={() => onRegionChange(region.id)}
                      className={`${
                        active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                      } block px-4 py-2 text-sm w-full text-left`}
                    >
                      {region.name}
                    </button>
                  )}
                </Menu.Item>
              ))}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>

      <Menu as="div" className="relative inline-block text-left">
        <Menu.Button className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none">
          {countries.find(c => c.id === selectedCountry)?.name || 'Select Country'}
          <ChevronDownIcon className="w-5 h-5 ml-2 -mr-1" aria-hidden="true" />
        </Menu.Button>

        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute left-0 z-10 w-56 mt-2 origin-top-left bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="py-1">
              {countries
                .filter(country => !selectedRegion || country.region === selectedRegion)
                .map((country) => (
                  <Menu.Item key={country.id}>
                    {({ active }) => (
                      <button
                        onClick={() => onCountryChange(country.id)}
                        className={`${
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'
                        } block px-4 py-2 text-sm w-full text-left`}
                      >
                        {country.name}
                      </button>
                    )}
                  </Menu.Item>
                ))}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}

export default LocationSwitcher;